import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { draftQuoteRequest } from 'src/app/services/market-place-quote-request-service/draft-quote-request.service';
import {
  CAR_TYPE,
  MarketPlaceQuoteRequestService,
} from '../../services/market-place-quote-request-service/market-place-quote-request.service';
import { REQUEST_STEPS } from '../search-inventory-component/request-quote-component/enum-request-steps';
import { StccsOption } from 'src/app/models/stcc-option.model';
import {
  filterSelectionState,
  OTHER,
} from '../search-cars-component/search-cars.helper.consts';
import { ConfirmationService, MessageService } from 'primeng/api';
import { MixpanelService } from '../../services/mixpanel-service/mixpanel.service';

@Component({
  selector: 'app-search-cars-landing',
  templateUrl: './search-cars-landing.component.html',
  styleUrls: ['./search-cars-landing.component.scss'],
})
export class SearchCarsLandingComponent implements OnInit {
  selectedProduct: StccsOption | undefined;
  enumCarTypes = CAR_TYPE;
  filteredSTCCs: Array<StccsOption> = [];
  boolDisplayProduct = false;
  productName = '';
  loading = false;
  constructor(
    public quoteRequestService: MarketPlaceQuoteRequestService,
    private draftQuoteService: draftQuoteRequest,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private router: Router,
    private mixpanelService: MixpanelService
  ) {
    this.quoteRequestService.stccList$.subscribe();
  }

  ngOnInit(): void {
    sessionStorage.removeItem(filterSelectionState);
    localStorage.removeItem('fromNewBuilds');
    this.quoteRequestService.setSelectedCarList([], []);
    this.getDraftQuote();
  }

  public async filterSTCC(event: any) {
    const query: string = event.query.toLowerCase();
    const filterSTCC = (stcc: StccsOption) =>
      stcc.description_stcc.toLowerCase().includes(query) ||
      stcc.description_stcc === 'Other';

    const options = await lastValueFrom(this.quoteRequestService.stccList$);
    this.filteredSTCCs = [OTHER, ...options].filter(filterSTCC);
  }

  searchByStcc(): void {
    const userEmail = localStorage.getItem('userEmail') || '';
    this.mixpanelService.track({
      id: userEmail,
      eventName: 'Search',
      eventDisplayName: this.selectedProduct?.description_stcc,
      kpi: 'CTR',
      trigger: 'On Button Click',
      eventDefinition: 'Selected STCC # ' + this.selectedProduct?.stcc,
      propertyType: 'Event Property',
      propertyDefinition: 'Search Result',
    });

    this.quoteRequestService.setDefaultStcc(this.selectedProduct);
    this.quoteRequestService.selectCarType('');
    if (this.boolDisplayProduct) {
      // means other is selected in STCC
      this.quoteRequestService.setProductName(this.productName);
    }
    this.beginSearch();
  }

  searchByCarType(carType: CAR_TYPE) {
    const userEmail = localStorage.getItem('userEmail') || '';
    this.mixpanelService.trackBeginTime(
      'Railcar Search button click time',
      userEmail
    );
    this.mixpanelService.track({
      id: userEmail,
      eventName: 'Search',
      eventDisplayName: `${carType}`,
      kpi: 'CTR',
      trigger: 'On Button Click',
      eventDefinition: `User clicks the Railcar Search ${carType}`,
      propertyType: `event property ${carType}`,
      propertyDefinition: `button label ${carType} search by car type`,
    });

    this.quoteRequestService.setDefaultStcc(undefined);
    this.quoteRequestService.selectCarType(carType);
    this.beginSearch();
  }

  beginSearch() {
    this.quoteRequestService.setNextStep(REQUEST_STEPS.MECHANICAL_OPTIONS);
    this.router.navigate(['/search-inventory/search-cars']);
    window.scrollTo(0, 0);
  }

  selectStcc(event: any) {
    if (event != undefined && event != null) {
      this.mixpanelService.track({
        eventName: 'Search',
        eventDisplayName: event?.description_stcc,
        kpi: 'Search',
        trigger: 'On Search',
        eventDefinition: 'Selected STCC # ' + event?.description_stcc,
        propertyType: 'Event Property',
        propertyDefinition: 'Search Result',
      });
      if (event.stcc === 'Other') {
        this.boolDisplayProduct = true;
        return;
      }
    }
    this.productName = '';
    this.boolDisplayProduct = false;
  }

  getDraftQuote() {
    this.loading = true;
    this.draftQuoteService.getDraftQuote().subscribe((response) => {
      this.loading = false;
      //alert(response[0]);
      if (response.length > 0) {
        this.confirmationService.confirm({
          message: `Please confirm if you would like to continue from where you left off previously.?
            The car no -' ${response[0].quote['selected-stcc']}`,
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.draftQuoteService.loadDraftQuote(response);
            this.messageService.add({
              severity: 'info',
              summary: 'Confirmed',
              detail: 'You have accepted',
            });
          },
          reject: () => {
            this.draftQuoteService.deleteQuote().subscribe();
            this.messageService.add({
              severity: 'warn',
              summary: 'Cancelled',
              detail: 'You have cancelled',
            });
          },
        });
      }
    });
  }
}
